export default __webpack_public_path__ + "static/media/element_60.f8e0726e.webp";